import React, { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { INVENTORY_DAYCARE_NESTED_ROUTE_DETAIL } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { FETCH_INVENTORY_DASHBOARD } from '../../../shared/constants/urlEndPoints';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { getMappedRoute } from '../../../utils/routeUtility';
import { INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS } from './../../../shared/constants/commonConstants';

const DaycareServices = ({ match, location }: any): ReactElement => {
  const dispatch = useDispatch();

  const nextDefaultPage = getMappedRoute(location?.pathname, INVENTORY_DAYCARE_NESTED_ROUTE_DETAIL)
    || INVENTORY_DAYCARE_NESTED_ROUTE_DETAIL[0].routeName;
  useEffect((): void => {
    dispatch(dashBoardRequest({
      title: INVENTORY_MESSAGE_CONSTANTS.title.dayCareSevices,
      url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: INVENTROY_CONSTANTS.dayCare,
    }));
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <NestedRoute
        match={match}
        defaultPage={nextDefaultPage}
        nestedNav={INVENTORY_DAYCARE_NESTED_ROUTE_DETAIL} />
    </div>
  );
};

export default DaycareServices;
